import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const ParentProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f6fbfa]">
        <div className="text-center">
          <div className="mx-auto mb-4 h-14 w-14 animate-spin rounded-full border-4 border-emerald-500 border-t-transparent"></div>
          <p className="text-emerald-700">Loading parent portal…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/parent/login" replace />;
  }

  return children;
};

export default ParentProtectedRoute;
